import type { ComponentType } from "react";
import {
  DASHBOARD_TENANTS,
  getDashboardTenantBySlug,
  type DashboardTenantDefinition,
  type DashboardTenantSlug,
  type EmbeddedRouteKey,
} from "./dashboard-tenants";
import { Dashboard } from "../pages/Dashboard";
import { Leaderboard } from "../pages/Leaderboard";
import { DailyReport } from "../pages/DailyReport";
import { Acquisition } from "../pages/Acquisition";
import { Closers } from "../pages/Closers";
import { Setters } from "../pages/Setters";
import { Content } from "../pages/Content";
import { PaymentCollection } from "../pages/PaymentCollection";
import { Leads } from "../pages/Leads";
import { CallLibrary } from "../pages/CallLibrary";
import { Financials } from "../pages/Financials";
import { UTMBuilder } from "../pages/UTMBuilder";
import { Settings } from "../pages/Settings";

export interface OfferDashboardPageDefinition extends DashboardTenantDefinition {
  pageImplementations: Record<EmbeddedRouteKey, ComponentType>;
}

const SHARED_EMBEDDED_PAGES: Record<EmbeddedRouteKey, ComponentType> = {
  dashboard: Dashboard,
  leaderboard: Leaderboard,
  "daily-report": DailyReport,
  acquisition: Acquisition,
  closers: Closers,
  setters: Setters,
  content: Content,
  "payment-collection": PaymentCollection,
  leads: Leads,
  calls: CallLibrary,
  financials: Financials,
  "utm-builder": UTMBuilder,
  admin: Settings,
};

export const OFFER_DASHBOARD_PAGES: Record<DashboardTenantSlug, OfferDashboardPageDefinition> = (
  Object.values(DASHBOARD_TENANTS) as DashboardTenantDefinition[]
).reduce((acc, tenant) => {
  acc[tenant.slug] = {
    ...tenant,
    pageImplementations: SHARED_EMBEDDED_PAGES,
  };
  return acc;
}, {} as Record<DashboardTenantSlug, OfferDashboardPageDefinition>);

export function getOfferDashboardDefinition(
  slug: string | null | undefined
): OfferDashboardPageDefinition | null {
  const tenant = getDashboardTenantBySlug(slug);
  if (!tenant) return null;
  return OFFER_DASHBOARD_PAGES[tenant.slug];
}
